import React from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import LightBoxPopup from '../LightBox';
import { VideoPlayer } from '../../VideoPlayer/LoadableVideoPlayer';
import s from './Video.scss';
var applyTheme = function (player) {
    return player.updateTheme({
        progressColor: '#00ff77',
    });
};
export var VideoPopup = function (_a) {
    var className = _a.className, onRequestClose = _a.onRequestClose, children = _a.children, source = _a.source, autoPlay = _a.autoPlay, posterFrame = _a.posterFrame;
    return (React.createElement(LightBoxPopup, { onRequestClose: onRequestClose },
        React.createElement(ErrorBoundary, null,
            React.createElement(VideoPlayer, { className: s['player'], src: source, autoPlay: autoPlay, fillAllSpace: true, loadingCover: posterFrame, onInit: applyTheme }))));
};
VideoPopup.displayName = 'VideoPopup';
export default VideoPopup;
//# sourceMappingURL=Video.js.map